/**
 * Identifies the message transaction type.
 * tag: 2804
 * @readonly
 * @enum {number} (int)
 */
export enum PayReportTransType {
  /** New */
  New = 0,
  /** Replace */
  Replace = 1,
  Status = 2,
}
